import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema4/GLB_PinPad.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class PinPad extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-10.6, -0.97, -2.1);
		this.scale.set(3, 3, 3);
		this.rotateY(1.55)
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.PinPad = gltf.scene.getObjectByName("Cube004", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const pinPadFolder = gui.addFolder("Pin Pad");
		pinPadFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		pinPadFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		pinPadFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		pinPadFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		pinPadFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		pinPadFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		pinPadFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		pinPadFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		pinPadFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		pinPadFolder.add(this, "visible").name("visible");
	}
	onAnimatePinPad() {
		this.clearAnimation()
		// const newMaterial = this.material.clone();
		// this.material = newMaterial;
		this.objectActiveAnimation = this.PinPad
		this.PinPad.material.emissive.set("#404040");

		this.animation = gsap.to(this.PinPad.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	clearAnimation() {
		if (this.animation) {
			this.animation.kill();
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation.material.emissive.set("#000000")
			this.objectActiveAnimation.material.emissiveIntensity = 0
			this.objectActiveAnimation = null
		}
	}
}